import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import {
    ScreenTrackingService,
    UserTrackingService,
    provideAnalytics,
    getAnalytics,
} from '@angular/fire/analytics';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MenuComponent } from './modules/menu/menu.component';
import { PrivacyPolicyModule } from './share/components/privacy-policy.module';
import { TermsAndConditionsModule } from './share/components/terms-and-conditions.module';
import { ConfirmController } from './share/controllers/confirm.controller';
import { AuthService } from './share/services/auth.service';
import { ProfileService } from './share/services/profile.service';
import { HttpService } from './share/services/http.service';
import { EndpointsService } from './share/services/endpoints.service';

import { IonicStorageModule } from '@ionic/storage-angular';
import { AuthInterceptor } from './share/interceptor/auth.interceptor';
import { AddressesService } from './share/services/addresses.service';
import { ZipCodeController } from './share/controllers/zipcode.controller';
import { BusinessService } from './share/services/business.service';
import { GeolocalizationService } from './share/services/geolocalization.service';
import { AppointmentsService } from './share/services/appointments.service';
import { NotificationsService } from './share/services/notifications.service';
import { PaymentMethodsService } from './share/services/payment-methods.service';
import { SalesService } from './share/services/sales.service';
import { CategoriesService } from './share/services/categories.service';
import { CartService } from './share/services/cart.service';
import { ProductsService } from './share/services/products.service';
import { PersonalizersService } from './share/services/personalizers.service';

import { BiometricService } from './share/services/biometric.service';
import { AngularFireModule } from '@angular/fire/compat';
import {
    AngularFireAuth,
    AngularFireAuthModule,
} from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import {
    provideAuth,
    getAuth,
    initializeAuth,
    indexedDBLocalPersistence,
} from '@angular/fire/auth';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { Capacitor } from '@capacitor/core';

// Importar FirebaseX

@NgModule({
    declarations: [AppComponent, MenuComponent],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        ScreenTrackingService,
        UserTrackingService,
        ConfirmController,
        ZipCodeController,
        AuthService,
        AngularFireAuth,
        ProfileService,
        PaymentMethodsService,
        AddressesService,
        EndpointsService,
        HttpService,
        CategoriesService,
        BusinessService,
        GeolocalizationService,
        CartService,
        ProductsService,
        PersonalizersService,
        AppointmentsService,
        NotificationsService,
        SalesService,
        BiometricService,
        provideFirebaseApp(() => {
            const app = initializeApp(environment.firebase);
            if (Capacitor.isNativePlatform()) {
                initializeAuth(app, {
                    persistence: indexedDBLocalPersistence,
                });
            }
            return app;
        }),
        provideAuth(() => getAuth()),
        provideFirestore(() => getFirestore()),
        provideMessaging(() => getMessaging()),
        providePerformance(() => getPerformance()),
        provideStorage(() => getStorage()),
        provideAnalytics(() => getAnalytics()),

    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireModule,
        AngularFirestoreModule,
        AngularFireAnalyticsModule,
        PrivacyPolicyModule,
        TermsAndConditionsModule,
    ],
})
export class AppModule {}
